<div class="bottom-float-tip" *ngIf="isShowingDetail">
    <ig-row>
        <ig-col [xs]="3">
            <!--<img [src]="imageService.imageSource(item)" alt="">-->
            <ig-image [imageUrl]="item.cover?.source"></ig-image>
        </ig-col>
        <ig-col [xs]="9" class="bottom-float-info">
            <p class="bottom-float-name">{{item.name}}</p>
            <p>{{item.address.address||item.address}}</p>
            <p>{{item.startTimeFormatted}}</p>
        </ig-col>
    </ig-row>
    <ig-row>
        <ig-col [xs]="isShowRemoveBtn?6:12">
            <ig-button class="green-btn" size="md" (trigger)="gotoDetails(item)">details
            </ig-button>
        </ig-col>
        <ig-col [xs]="6" *ngIf="isShowRemoveBtn">
            <ig-button class="red-btn" size="md" (trigger)="remove(item)"><span>remove</span> <span class="hide-on-small">from trip</span>
            </ig-button>
        </ig-col>
    </ig-row>

    <div class="bottom-float-index" *ngIf="index!==-1">{{index + 1}}</div>
    <div class="bottom-float-icon" *ngIf="index===-1"><img [src]="greenMapIcon" width="20px" alt=""></div>
    <div class="bottom-float-close" (click)="close()"><mat-icon>close</mat-icon></div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.map.bottom.info/trip.map.bottom.info.component.html